module.exports = __webpack_public_path__ + "img/IMG_8988.132ead9d.jpg";